import { render, staticRenderFns } from "./Cy.vue?vue&type=template&id=f4490624&scoped=true&"
import script from "./Cy.vue?vue&type=script&lang=js&"
export * from "./Cy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4490624",
  null
  
)

export default component.exports